// TODO update this to import from commmons
// import { gql } from '@reverbdotcom/commons/src/gql';
// eslint-disable-next-line no-restricted-imports
import { gql } from '@apollo/client';
import React from 'react';
import I18n from 'i18n-js';
import { Item2DescriptionData } from '@reverbdotcom/commons/src/gql/graphql';
import SanitizedRender from '@reverbdotcom/commons/src/components/sanitized_render';
import { RCAccordion } from '@reverbdotcom/cadence/components';
import { MParticleEventName, trackEvent } from '@reverbdotcom/commons/src/elog/mparticle_tracker';
import { Item2Prop65Warning, Item2Prop65WarningFragment } from './item2_prop65_warning';
import { TruncationContainer } from '@reverbdotcom/commons/src/components/truncation_container';
import { Item2BuyerProtection } from './item2_buyer_protection';

const TRUNCATION_CONTAINER_REM_HEIGHT = 20;

const trackClick = (collapsed, listing) => {
  trackEvent({
    eventName: MParticleEventName.ClickedAccordion,
    componentName: 'Item2Description',
    interactionType: collapsed ? 'collapse' : 'expand',
    listing,
  });
};

export const Item2DescriptionFragment = gql`
  fragment Item2DescriptionData on Listing {
    _id
    id
    description
    soldAsIs
    ...Item2Prop65WarningData
  }
  ${Item2Prop65WarningFragment}
`;

interface IProps {
  listing: Item2DescriptionData.Fragment;
}

export function Item2Description({ listing }: IProps) {

  if (!listing) return null;

  return (
    <div className="item2-description">
      <RCAccordion
        heading={I18n.t('discovery.item2Description.about')}
        defaultOpen
        size="large"
        id="description"
        onToggle={(collapsed) => trackClick(collapsed, listing)}
      >
        <TruncationContainer
          remMaxHeight={TRUNCATION_CONTAINER_REM_HEIGHT}
          trackingName="Item2Description"
        >
          <SanitizedRender
            html={listing.description}
            htmlTag="div"
            className="item2-description__content"
            truncationHeight={null}
          />
        </TruncationContainer>
        <Item2Prop65Warning
          listing={listing}
        />
        <Item2BuyerProtection
          listing={listing}
        />
      </RCAccordion>
    </div>
  );
}
